import {Branding} from '../Branding.types'

import LogoHM from './icons/Logo-HM-Compact-Negative.svg'

export const hubHeidelbergMaterialsDk: Branding = {
  nationalBrandName: 'Heidelberg Materials',
  nationalLogoUrl: LogoHM,
  nationalLogoTitle: 'Heidelberg Materials',
  nationalUrl: 'https://www.heidelbergmaterials.dk/',
  contactEmail: 'hub-dk@heidelbergmaterials.com',
  contactEmailSubject: 'Mail from Hub Portal',
  pageTitle: 'Heidelberg Materials',
  country: 'DK'
}
